import React, { useContext } from 'react';
import AppContext from '../../context/AppContext';
import TeamItem from '../TeamItem';
import ModalShare from '../ModalShare';
import CartolaBanner from '../CartolaBanner';

import styles from './TeamsList.module.scss';

function TeamsList() {
  const { getAthlete, teams } = useContext(AppContext);

  const reducer = (previousValue, currentValue) => previousValue + currentValue;

  const sortedTeams = [...teams]
    .map((team) => {
      const atletas = team.athletes.map((athlete) => getAthlete(athlete));
      const updatesAtletas = atletas.filter((atleta) => atleta);
      const idAtletasUpdate = updatesAtletas.map((atleta) => atleta.id);

      return {
        ...team,
        athletes: updatesAtletas,
        total: idAtletasUpdate
          .map((key) => getAthlete(key).eval)
          .reduce(reducer, 0),
      };
    })
    .sort((a, b) => {
      let response;
      const diff = b.total - a.total;
      if (diff !== 0) response = diff;
      else response = a.name.localeCompare(b.name);

      return response;
    });

  return (
    <>
      <ul className={styles.wrapper}>
        {sortedTeams.map((team, index) => (
          <TeamItem key={`Team__key__${index}__${Math.random()}`} team={team} />
        ))}
      </ul>
      <CartolaBanner />
      <ModalShare />
    </>
  );
}

export default TeamsList;
